import { FixedPageHeader } from 'Components/Layout';
import { useSelector } from 'react-redux';

const FixedAgsExportHeader: React.FC = () => {
  const status = useSelector((state) => state.agsExport.pageHeader?.status);
  const processing = useSelector((state) => state.agsExport.pageHeader?.processing);
  const caption = useSelector((state) => state.agsExport.pageHeader?.shortName);
  const identifier = useSelector((state) => state.agsExport.pageHeader?.identifier);

  return (
    <FixedPageHeader
      pageIdentifier={identifier}
      pageStatus={status}
      pageProcessing={processing}
      pageCaption={caption}
    />
  );
};

export default FixedAgsExportHeader;
